import { GQLOffers, GQLUrls } from "@gql/types/gql";
import React from "react";
import Image from "next/legacy/image";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";
import { translate } from "@helpers/translationObjectFormatter";
import styles from "./style.module.scss";
import { PLACE_HOLDER_IMAGE_PATH, resolveURL } from "@lib/sharedUtils";
import { removeWordFromString } from "@helpers/removeWordFromString";
import { VendorsToCompare } from "@components/shared/sideWidget";

const VendorsSideBySideComparison = ({
    vendorsToCompare,
    vendor,
    secondStyle = false,
}: {
    vendorsToCompare: VendorsToCompare[];
    vendor: GQLOffers;
    secondStyle?: boolean;
}) => {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const { data: categoryUrl } = useQuery<GQLUrls>(["categoryUrl"]);

    const buildOrderedComparisonUrl = (
        vendor1: string,
        vendor2: string,
    ): string => {
        vendor1 = removeWordFromString(vendor1);
        vendor2 = removeWordFromString(vendor2);
        if (vendor1.localeCompare(vendor2) < 0) {
            return `${vendor1}-vs-${vendor2}`;
        }
        return `${vendor2}-vs-${vendor1}`;
    };
    return (
        <div
            className={`${
                secondStyle ? "mt-3 max-h-[350px] px-3" : " max-h-[200px]"
            }  flex flex-col  overflow-auto mb-2 ${
                secondStyle ? styles["scrollContainer"] : styles.container
            }`}
        >
            {vendorsToCompare?.map((item) => (
                <a
                    href={`${resolveURL(
                        categoryUrl as GQLUrls,
                    )}/comparison/${buildOrderedComparisonUrl(
                        vendor.slug as string,
                        item.slug,
                    )}`}
                    key={`${resolveURL(
                        categoryUrl as GQLUrls,
                    )}/comparison/${buildOrderedComparisonUrl(
                        vendor.slug as string,
                        item.slug,
                    )}`}
                    className="border-b border-b-[#e7e7e7] last:border-none py-5"
                >
                    <span
                        className={`flex flex-row cursor-pointer items-center gap-3 ps-4 py-1 hover:bg-[#f2f8ff]  flex-grow`}
                    >
                        <span className="p-[6px] rounded-full font-extrabold text-xl text-[#0e2450] ">
                            {translate(translations, "several_general_vs")}
                        </span>

                        <span
                            className={`relative block ${styles["topBuyerImage"]}  mt-1  lg:h-[50px]  h-[40px] flex-grow`}
                        >
                            {item.logo ? (
                                <Image
                                    src={item?.logo}
                                    alt={item?.label ?? item?.slug}
                                    layout="fill"
                                    className="max-h-[45px]  w-full  relative block"
                                />
                            ) : (
                                <>
                                    <Image
                                        src={PLACE_HOLDER_IMAGE_PATH}
                                        alt="logo"
                                        objectFit="contain"
                                        width={150}
                                        height={40}
                                    />
                                </>
                            )}
                        </span>
                    </span>
                </a>
            ))}
        </div>
    );
};

export default VendorsSideBySideComparison;
